<template>
  <div class="message-info">
    <div class="default-message">{{ $t('QUESTION_FORM.SUBMITTED') }}</div>
    <div v-if="question.type==='QUIZZ' && question.successDefeatMessage.display===true" v-html="resume()"></div>
    <user-score v-if="selectedPoll.isAsync && votedAll && isLastQuestion"></user-score>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserScore from './UserScore.vue';

export default {
  name: 'question-form-submitted',
  components: {
    UserScore
  },
  props: {
    question: Object
  },
  computed: {
    ...mapGetters({
      lang: 'getInputLanguage', 
      votedAll: 'userHasVotedAll', 
      selectedPoll: 'selectedPoll', 
      isLastQuestion: 'isLastQuestion',
      currentQuestionScore: 'currentQuestionScore'
    }),
  },
  methods: {
    resume() {
      const score = this.currentQuestionScore;
      if (typeof score === 'number') {
        const msg = score > 0 ? this.question.successDefeatMessage.successTexts[this.lang] : this.question.successDefeatMessage.defeatTexts[this.lang];
        const lines = msg.split('\n');
        return lines.map(l => (`<span>${l}</span><br/>`)).join('');
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.message-info {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: space-evenly;
}
.default-message {
  font-size: 20px;
}
</style>
